export default {
  sample: {
    home2: 'Home 2',
  },
  common: {
    hrportal: 'Dashboard',
    menu: 'Site Map',
    commonSetting: 'Common Setting',
    ok: 'OK',
    cancel: 'Cancel',
    close: 'Close',
    save: 'Save',
    back: 'Back',
    add: 'Add',
    reset: 'Reset',
    create: 'Create',
    caution: 'Caution',
    noDataFound: 'No Data Found',
    saved: 'Saved',
    copied: 'Copied',
    deleted: 'Deleted',
    delete: 'Delete',
    upload: 'Upload',
    format: 'format',
    all: 'all',
    selectTarget: 'Select target',
    goBackToEditing: 'Go back to editing',
    discard: 'Discard',
    discardDialogTitle: 'Discard unsaved changes?',
    discardConfirmMessage:
      'The current changes will not be saved if you continue to discard.',
    week: {
      mon: 'Mo',
      tue: 'Tu',
      wed: 'We',
      thu: 'Th',
      fri: 'Fr',
      sat: 'Sa',
      sun: 'Su',
    },
    goHomeText: 'Go back home',
  },
  appbar: {
    placeholder: 'Search menu',
    searchMessage: 'Search by menu name or description',
    setting: 'Personal Settings',
    logout: 'Logout',
    userManual: 'User Manual',
    version: 'Version',
    aboutFbs: 'About File Bridge Scheduler',
    aboutPortal: 'About COMPANY HR Portal',
    fbsCopyright: '© 2025 Works Human Intelligence Co., Ltd.',
    portalCopyright: '© 2023 Works Human Intelligence Co., Ltd.',
    ossLicense: 'OSS License',
  },
  sidemenu: {
    home: 'Home',
  },
  portal: {
    notification: 'Notification',
    event: 'Event',
    favorite: 'Favorite',
    hideFavorite: 'Hide this panel',
    updateFavorite: 'Favorite Setting',
    history: 'History',
    links: 'Links',
    unavailableDescription: 'Not accessible from your device',
    nofavoritemsg: '- You can add your favorite menu from here',
    titleHideFavorite: 'Hide favorites',
    titleHideFavoriteSub1: 'Prevents the Favorites from appearing.',
    titleHideFavoriteSub2: 'You can display it again from the settings.',
    titleUpdateFavorite: 'Update Favorites',
    updateLink: 'Update Links',
    linkEditTitle: 'Title',
    linkEditUrl: 'URL',
    linkEditDescription: 'Description',
    linksUpdation: 'Update Links',
    linkAdd: 'Add Link',
    linkEdit: 'Edit Link',
    ruleInputRequired: 'Required.',
    ruleInputUnique: 'JobCode Must be unique within landscape.',
    ruleInputAlphanumericFormat:
      'Only alphanumeric charcters or underscore(_) are allowed.',
    ruleInputRegExpCompilable:
      'The input cannot be processed as a valid match pattern. Please note that symbols may have special meanings. Refer to the user manual for more details.',
    ruleInputUrl: 'Invalid URL.',
    ruleSSMParameterStoreName:
      'Only a mix of letters, numbers and the following 3 symbols .-_ are allowed.',
    noData: 'No Data',
    disableDueToNotInHouse: 'Disabled due to not in-House IP',
    application: 'Application',
    seeAll: 'See All',
    announcement: 'Announcement',
    announcements: 'Announcements',
  },
  setting: {
    settingItemLanguage: 'Language',
    settingItemUseFavorite: 'Use Favorite function',
    updatedMessage: 'Updated',
    regionAndLanguage: 'Display',
    generalSetting: 'Features',
  },
  commonSetting: {
    tabs: {
      announcement: 'Announcement',
      webApi: 'Credential Settings',
      general: 'Features',
      userManagement: 'User Management',
      role: 'Role',
    },
    announcementTableColumn: {
      title: 'Title',
      content: 'Content',
      linkToProductMenu: 'Link',
      isPublic: 'Public',
      displayStartDate: 'Start date',
      displayEndDate: 'End date',
      priorityTag: 'Priority',
      updatedAt: 'Update datetime',
    },
    isPublicLabel: {
      public: 'Public',
      private: 'Private',
    },
    priorityTagLabel: {
      high: 'High',
      medium: 'Medium',
      low: 'Low',
    },
    cardTitle: {
      newItem: 'New Item',
      editItem: 'Edit Item',
    },
    error: {
      afterTodayDate: "End date cannot be before today's date",
      beforeStartDate: 'End date cannot be before Start date',
      required: 'This field is required',
      invalidDate: ' is not a valid date',
    },
    general: {
      settingItemMultilanguage: 'Use Multi-language',
      settingItemUseJobScheduler: 'Use Job and Scheduler feature',
      useV1: 'Use CWS Announcement',
      useV2: 'Use COMPANY HR Portal Announcement',
      notUse: 'Not use Announcement',
      saveConfirmation: 'Do you want to save your changes?',
    },
    webApi: {
      authenticationInfoSetting: 'Credential',
      authenticationInfoSettingHint:
        'Please use Client ID and Client Secret configured in Client-ID Management Screen of CJK.',
      clientId: 'Client ID',
      clientSecret: 'Client Secret',
      createDialogTitle: 'Are you sure you want to save authentication info?',
      deleteDialogTitle: 'Are you sure you want to remove authentication info?',
      createTooltip: 'Save Client ID and Client Secret',
      deleteTooltip: 'Remove Client ID and Client Secret',
      deleteDialogText: `Job execution will fail if you delete authentication info. The credentials will be removed from this application but will remain in the CJK Client-ID management dashboard`,
    },
    userManagement: {
      searchHint: 'Search by User Name or User Role',
      userDetail: 'User Detail',
      adminRole: 'Admin',
      generalRole: 'General',
      userNameHeader: 'User Name',
      userRoleHeader: 'User Role',
      roleHeader: 'Role',
      selectRole: 'Select Role',
      searchToLoadUserDetails: 'Search to load user data',
      sameAsLoggedInUser:
        'You cannot change your user role or delete your own user data',
      deleteDialogTitle: 'Delete User Data',
      deleteDialogTextDeleteUserDataConfirmation:
        'Are you sure you want to permanently delete all data of the user: ',
      deleteDialogPortalDataDeletionCaution: `・Only the data stored in COMPANY HR Portal will be deleted. If login credentials exist in SAML data, the user will still be able to log in. To prevent the user from logging in, you must delete the login credentials from the SAML data as well.`,
      deleteDialogSamlLoginCaution: `・Even after deletion, if the user attempts to log in while their credentials in the SAML IdP still exist, their user data will be recreated in COMPANY HR Portal.`,
      deleteDetailsConfirmation:
        'The following data will be deleted. Please confirm by checking the checkbox:',
      deleteDetailsConfirmUserDataDelete: 'All data created for this user',
      deleteDetailsConfirmUserDataReplace:
        'Any mentions of this user will be replaced with the text "deleted user"',
      typeUserName: `To confirm deletion, please type the user's name in the text input field below.`,
      deletionProcessStarted: 'Deletion process started',
      deletionProcessComplete: 'Deletion process complete',
      deletionProcessFailed: 'Deletion process failed',
    },
    roleManagement: {
      title: 'Role Management',
      createNewRole: 'Create New Role',
      systemRole: 'System Role',
      roleNameHeader: 'Role Name',
      defaultHeader: 'Default',
      descriptionHeader: 'Description',
      actionsHeader: 'Actions',
      yes: 'Yes',
      no: 'No',
      edit: 'Edit',
      delete: 'Delete',
      systemRoleCannotBeDeleted: 'System roles cannot be deleted',
      deleteDialogTitle: 'Delete Role',
      deleteConfirmMessage: 'Are you sure you want to delete',
      cancel: 'Cancel',
      loadFailed: 'Failed to load roles',
      deleteSuccess: 'Role deleted successfully',
      deleteFailed: 'Failed to delete role',
      usersAssignedDialogTitle: 'Cannot Delete Role',
      usersAssignedMessage:
        'This role has {count} user(s) assigned to it. Please move all users to another role before deleting this role.',
    },
    roleEdit: {
      editTitle: 'Edit Role',
      createTitle: 'Create New Role',
      systemRoleCannotBeEdited: 'System roles cannot be edited',
      roleName: 'Role Name',
      roleNameRequired: 'Role name is required',
      description: 'Description',
      defaultRoleLabel: 'Default role for first-time login users',
      defaultRoleHint:
        'Only one default role can be set. Setting this role as default will automatically unset the existing default role.',
      menuPermissionsLabel: 'Menu Display Permissions',
      scheduler: 'Scheduler',
      job: 'Job',
      settings: 'Settings',
      cannotChangeOwnRoleSettings:
        'Cannot change settings permission for your own role',
      home: 'Home',
      sitemap: 'Sitemap',
      cancel: 'Cancel',
      update: 'Update',
      create: 'Create',
      settingsPermissionDialogTitle: 'Confirm Permission Grant',
      settingsPermissionWarning:
        'Warning: Granting settings permission allows access to all user information within the tenant. Please assign this permission carefully.',
      grant: 'Grant',
      disablePermissionDialogTitle: 'Confirm Permission Removal',
      disableSettingsConfirm:
        'Are you sure you want to disable settings permission?',
      disable: 'Disable',
      defaultRoleDialogTitle: 'Confirm Default Role Setting',
      defaultRoleWarning:
        'Warning: The default setting for the existing default role "{roleName}" will be automatically disabled. Continue?',
      set: 'Set',
      fetchFailed: 'Failed to fetch role information',
      noPermission: 'You do not have permission to access this role',
      updateSuccess: 'Role updated successfully',
      createSuccess: 'Role created successfully',
      saveFailed: 'Failed to {action} role',
    },
  },
  dataTable: {
    footer: {
      itemsPerPageText: 'Rows per page',
    },
  },
  search: {
    notFound: '- No matching menu found.',
    results: 'results',
    seconds: 'seconds',
  },
  errorBoundary: {
    title: 'An unexpected error has occurred',
    occurredTime: 'Occurred Time',
    errorCode: 'Error Code',
    errorTitle: 'Error Title',
    argsInfo: 'Arguments',
    errorMessage: 'Error Message',
    stackInfo: 'Stack',
    errorInfo: 'Error Info',
  },
  editor: {
    // Write the key in a snake case according to the library we are using
    tooltip: {
      undo: 'Undo',
      redo: 'Redo',
      bold: 'Bold',
      italic: 'Italic',
      strike: 'Strike',
      underline: 'Underline',
      code: 'Code',
      paragraph: 'Paragraph',
      heading: 'Heading',
      bullet_list: 'Bullet List',
      ordered_list: 'Ordered List',
      horizontal_rule: 'Horizontal Line',
    },
  },
  productMainMenu: {
    CSR: 'Attendance Management',
    CWS: 'Workforce Self-Service',
    CJK: 'HCM & Payroll',
    CTM: 'Talent Management',
  },
  productMainMenuForTakeda: {
    CSR: 'Attendance Management',
    CWS: 'HR Self Workflow',
    CJK: 'Human Resource and Payroll',
    CTM: 'Talent Search Portal',
  },
  announcement: {
    highPriorityFlg: 'High',
    mediumPriorityFlg: 'Medium',
    lowPriorityFlg: 'Low',
    displayPeriodLabel: 'Display Period',
    contentLabel: 'Content',
    updateDateLabel: 'Update Date',
    urlLabel: 'URL',
    noAnnouncement: 'There is no announcement',
  },
  pageNotEnabled: {
    titleText: 'Sorry, this feature is disabled',
    subText: 'Please contact administrator for enabling this feature.',
  },
  pageNotFound: {
    titleText: "Sorry, this page isn't available",
    subText: 'The link may be broken, or the page may have been removed.',
  },
  jobScheduler: {
    common: {
      scheduler: 'Scheduler',
      period: {
        title: 'Period',
        to: 'To',
        from: 'From',
        executeOn: 'Execute on',
        setAt: 'Set at',
      },
      repeatType: {
        itemName: 'Repeat Type',
        repeatTypeOptions: {
          noRepeat: 'No Repeat',
          daily: 'Daily',
          monthly: 'Monthly',
          weekly: 'Weekly',
          firstDayOfMonth: 'First Day of Month',
          lastDayOfMonth: 'Last Day of Month',
        },
      },
      holidayLabel: {
        title: 'Label',
        placeholder: 'Attach any labels here',
        notFound: ' is not found. Press enter to create a new one',
        allSelected: 'Press enter to create a new one',
      },
      accessFromOutsideOfJST: {
        titleText:
          "To access this page your system's timezone should be Japan Standard Time (JST)",
        subText:
          "Your system's timezone is not set to Japan Standard Time (JST). Please set the timezone to Japan Standard Time (JST) to access this page.",
      },
      accessFromIOS: {
        titleText: 'Use recommended environment for this page',
        subText:
          'This page might not load properly on this device and browser. To use this feature, please check the "Recommended Environment" in User Manual.',
        ignoreWarning: 'Ignore',
      },
      abortAndDelete: 'Abort and Delete',
      abortedAndDeleted: 'Aborted and Deleted',
      copy: 'COPY - ',
      dateToLessThanDateFrom: 'Start date should be less than End date',
      moreActions: 'More Actions',
      notSelectedDates: 'No date is selected',
      notSelectedDays: 'No day is selected',
      notSelectedEndDateHint:
        'If you do not specify the end date, it will continue forever',
      notSelectedPeriod: 'Period is not selected',
      editTooltip: 'Edit',
      viewTooltip: 'View',
      viewDisabledDueToNoEventMetadataToolTip:
        'Cannot view details of 3 year old events',
      copyTooltip: 'Copy',
      copyDisabledDueToNoEventMetadataToolTip:
        'Cannot copy details of 3 year old events',
    },
    eventCalendar: {
      calendar: 'Calendar',
      list: 'List',
      search: 'Search',
      clear: 'Clear',
      executionStatus: 'Execution Status',
      executionType: 'Execution Type',
      downloadSearchResult: 'Download Search Result',
      task: 'Task',
      showMore1: 'Show More (Total ',
      showMore2: ' items)',
      searchResult: 'Search Result: ',
      item: ' items',
      invalidDate: 'Invalid date and time',
      notSpecified: 'Not Specified',
      immediate: 'Immediate',
      scheduled: 'Scheduled',
      throughAPI: 'ThroughAPI',
      throughFsync: 'ThroughFsync',
      retry: 'Retry',
      succeeded: 'Succeeded',
      failed: 'Failed',
      notTriggered: 'Not Triggered',
      running: 'Running',
      todayText: 'TODAY',
      job: 'Job',
      output: 'Output',
      download: 'Download',
      executedBy: 'Executed by',
      executedAt: 'Executed at',
      executeCompletedAt: 'Completed at',
      executeAt: 'Execute at',
      updatedBy: 'Last modified by',
      updatedAt: 'Last modified at',
      result: 'Result',
      labels: 'Labels',
      moreThan1000ConsecutiveHolidayDialogTitle:
        'Not supported event schedule exists',
      moreThan1000ConsecutiveHolidayDialogText:
        'An event exists whose execution period overlaps with a period containing at least \
        1000 consecutive holidays. Such a schedule specification is not supported \
        and because of that we are unable to calculate \
        the correct execution date for that {eventDetailLink}.\
        Either delete those consecutive holidays or change the holiday trigger setting for that event.',
      eventText: 'event',
    },
    jobs: {
      title: 'Job',
      addNewTask: 'Add New Task',
      jobCode: 'Job Code',
      jobCodeDescription: 'This is a string to uniquely manage the job.',
      jobCodeHint: '※Cannot be edited once saved',
      jobTitle: 'Job Title',
      jobDescription: 'Job Description',
      jobTriggerFilePath: 'Trigger File Path',
      jobTriggerFilePathDescription:
        'If you want to use the File Synchronizer Agent Service to trigger a job when a file is uploaded, please set a pattern to identify the location of the target file. This pattern should be specified based on the rules of regular expressions, so please refer to the user manual for detailed formatting information.',
      taskDetail: 'Task Detail',
      notSetTask: 'No Task Selected',
      taskSelection: 'Select a task',
      newJob: 'Create Job ',
      searchJobTitle: 'Search job title',
      searchJobTitleOrJobCode: 'Search by job title or job code',
      jobExecute: 'Execute Immediately',
      noJobSelected: 'No Job Selected',
      taskTitle: 'Task Title',
      addMore: 'Add File to Upload',
      uploadAndExecute: 'Upload And Execute',
      uploadOnExecuteDialogTitle: 'Execute Job',
      uploadFileSubtitle:
        '(Optional) Upload files to COMPANY V8 before execution',
      destinationFilePath: 'Destination File Path',
      hintForDestinationFilePath: 'e.g. /folder1/file.txt',
      invalidPath:
        'File path is invalid. Example of valid path: /folder1/file.txt',
      duplicateOutputFilePath: 'Same output file path exists for other task(s)',
      fileInput: 'File to Upload',
      chooseFile: 'Choose File',
      doUploadOnExecuteOrNotText:
        'Do you want to upload any files to COMPANY V8 before job execution?',
      uploading: 'Uploading',
      executing: 'Executing',
      executed: 'Executed',
      executedDialogTitle: 'Selected job has been executed.',
      executedDialogText:
        'You can check job execution status in {eventCalendarLink} page.',
      includeInDownload: 'Include in download',
      replaceInFileName: 'Replace reserved words in file name',
      selectFile: 'Select job file',
      importJobFile: 'Import job file',
      importableFileDescription:
        'Only job files generated using the export function can be imported. Exported files cannot be edited',
      importableFileFormat: 'Only csv/yaml (yml) files can be imported',
      import: 'Import',
      exportJobFile: 'Export job file',
      exportTarget: 'Export target',
      export: 'Export',
      importJobAlreadyStarted:
        'Another user is currently importing jobs. Please wait a moment and try again later.',
      importJobStarted: 'Job import has started',
      importJobCompleted: 'Job import completed',
      importJobFailedStatus422:
        'Job import failed. Files that have been edited after being exported cannot be imported.',
      importJobFailedTimeout: 'Job import failed. Please try again later.',
    },
    holidays: {
      holiday: 'Custom Holiday',
      holidayTitleInput: 'Custom Holiday Title',
      holidayDescriptionInput: 'Custom Holiday Description',
      createHolidayTitle: 'Create Custom Holiday',
      copyHolidayTitle: 'Copy Custom Holiday',
      updateHolidayTitle: 'Edit Custom Holiday',
      viewHolidayTitle: 'View Custom Holiday (Read-only)',
      holidayDetail: 'Custom Holiday Detail',
      abortDialogTitle: 'Delete all future custom holidays?',
      abortTooltip: 'Delete all future custom holidays',
      abortConfirmMessage: 'All future custom holidays will be deleted.',
      notSelectedCustomHolidayLabels:
        'Need to input at least one custom holiday label',
    },
    events: {
      event: 'Event',
      createEventTitle: 'Create Event',
      copyEventTitle: 'Copy Event',
      updateEventTitle: 'Edit Event',
      viewEventTitle: 'View Event (Read-only)',
      eventTitleInput: 'Event Title',
      eventDescriptionInput: 'Event Description',
      jobToRun: 'Job',
      eventDetail: 'Event Detail',
      executionTime: 'Execution Time',
      executionDateTime: 'Execution',
      startDateTime: 'Start',
      executionTimeNotInputted: 'Execution Time is not inputted',
      abortDialogTitle:
        'Abort the event schedule and delete all future events?',
      abortTooltip: 'Abort the event schedule and delete all future events',
      abortConfirmMessage:
        'This event schedule will be aborted and all future events will be deleted.',
      notSelectedHolidayLabels: 'Need to input at least one holiday label',
      retryTooltip: 'Retry',
      retryDisabledDueToNoEventMetadataToolTip:
        'Cannot retry execution of 3 year old events',
      retryDialogTitle: 'Retry Event Execution',
      retryFromFailed: 'Retry From Failed Task',
      retryAll: 'Retry All',
      retry: 'Retry',
      holidayTriggerSettingTitle: 'Holiday Trigger Setting',
      holidayTrigger: {
        label: 'Holiday Option',
        noChange: 'No Change',
        skip: 'Skip',
        triggerAfterHoliday: 'Trigger after holiday',
        triggerBeforeHoliday: 'Trigger before holiday',
        allHoliday: 'All Holidays',
        customHoliday: 'Specific Holidays',
        on: 'On',
        noLabelData: 'No labels available',
      },
      selectedToday:
        ' time is before or the same as the current time. Event will not be triggered today.',
    },
  },
};
